import { from } from 'rxjs'
import { mergeMap } from 'rxjs/operators'
import { ofType } from 'redux-observable'
import * as actionTypes from '../../../constants/actionTypes'
import setupActions from '../../../actions/setup'
import { setLiveTime } from '../../../actions/gig/gigActions'
import { setBookingStatus } from '../../../actions/docs/docsActions'

const setBookingInitialState$ = (actions$, state) => actions$.pipe(
  ofType(actionTypes.SET_BOOKING_DOCUMENT),
  mergeMap(() => {

    const actionsToDispatch = []
    const { data: { status }, dateUpdated } = state.value.docs.bookingDoc

    if (status) {

      actionsToDispatch.push(setBookingStatus(status))

      if (status === 'LIVE') {

        actionsToDispatch.push(setLiveTime(dateUpdated))

      }

    }

    actionsToDispatch.push(setupActions.setBackendDocumentStateComplete())

    return from(actionsToDispatch)

  })
)

export default setBookingInitialState$
